import * as React from "react";
const SvgIcWalletFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18 2H1V22H23V7H7C5.89543 7 5 6.10457 5 5H18V2Z" fill="currentColor" /></svg>;
export default SvgIcWalletFilled;